import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";
import { objectToQueryParams } from "@src/helper/objectToQueryParams";

const api = apiInstance()

export const getJobVacancies = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/job-vacancies${newParams ? `?${newParams}` : ""}`)
}

export const getJobVacancyFilters = async () => {
  return api.get(`/${PUBLIC_V1}/module/portal/job-vacancies/filters`)
}

export const getJobVacancyDetail = async (id) => {
  return api.get(`/${PUBLIC_V1}/module/portal/job-vacancies/${id}`)
}

export const postJobApplication = async ({ jobVacancyId, payload }) => {
  return api.post(`/${PUBLIC_V1}/module/portal/job-vacancies/${jobVacancyId}/job-applications`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}
